import type { CSSProperties, ReactNode } from "react";

/**
 * 로딩 자리 — 빛이 흐르는 빈 네모(shimmer). 「…」나 멈춘 회색 칸은 멈춘 것처럼 보여
 * 기다리는 사람이 지친다(사용자 지시 2026-09-23). 크기는 호출부가 className 으로 준다.
 */
export function Skeleton({ className = "", style }: { className?: string; style?: CSSProperties }) {
  return <span aria-hidden data-testid="skeleton" className={`skeleton block rounded ${className}`} style={style} />;
}

/** 돌아가는 원 — 표 밖의 짧은 대기(본문·짝 전문·저장 중)에 글 옆에 둔다. */
export function Spinner({ size = 14, className = "" }: { size?: number; className?: string }) {
  return (
    <span role="status" aria-label="불러오는 중"
      className={`inline-block shrink-0 animate-spin rounded-full border-2 border-muted-foreground/30 border-t-muted-foreground ${className}`}
      style={{ width: size, height: size }} />
  );
}

/** 스피너 + 문구 한 줄. `<Loading>본문을 불러오는 중…</Loading>` */
export function Loading({ children = "불러오는 중…", className = "" }: { children?: ReactNode; className?: string }) {
  return <p className={`ty-caption flex items-center gap-2 text-muted-foreground ${className}`}><Spinner />{children}</p>;
}
